<script>
  import Modal from "../../components/Modal.svelte"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { user } from "../../stores/User"
  import { createEventDispatcher } from "svelte"
  import Container from "../../components/Container.svelte"

  const dispatch = createEventDispatcher()
  export let cliente

  let isOpenModalTelefonos = false

  let telefono_tipo = ""
  let telefono = ""
  let isSettingTelefono = false

  const handleAgregarTelefono = () => {
    isOpenModalTelefonos = true
  }

  const updateTelefonoVerificado = async () => {
    if (telefono_tipo === "") {
      return
    }

    if (telefono.length !== 9 || telefono.charAt(0) !== "9") {
      //El telefono debe iniciar con 9 y tener 9 dígitos
      alert("Por favor, ingrese un número de teléfono válido.")
      return
    }

    isSettingTelefono = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "updateTelefonoVerificado",
        id: cliente.id,
        telefono,
        tipo: telefono_tipo,
        session_key: $user.session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      telefono_tipo = ""
      telefono = ""
      isOpenModalTelefonos = false
      dispatch("update")
    } else {
      console.error("Error al actualizar teléfono verificado:", data.message)
    }
    isSettingTelefono = false
  }
</script>

<Container>
  <div class="d-flex justify-content-between align-items-center">
    <h6 class="text-start">
      <i class="bi-telephone fg-secondary me-3"></i> Teléfonos verificados
    </h6>
    <button class="btn btn-sm fg-primary" on:click={handleAgregarTelefono}
      ><i class="bi bi-pencil-square"></i></button
    >
  </div>
  <div class="table-responsive">
    <table class="table table-striped table-sm small">
      <tbody>
        <tr>
          <td class="fg-secondary">Principal</td>
          <td class="text-end">{cliente.telef_principal}</td>
          <td>
            {#if cliente.telef_principal != ""}
              <a
                target="_blank"
                href="https://api.whatsapp.com/send/?phone=51{cliente.telef_principal}&text&app_absent=0"
                class="fg-success"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-whatsapp"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
                  />
                </svg>
              </a>
            {/if}
          </td>
        </tr>
        <tr>
          <td class="fg-secondary">Secundario</td>
          <td class="text-end">{cliente.telef_secundario}</td>
          <td>
            {#if cliente.telef_secundario != ""}
              <a
                target="_blank"
                href="https://api.whatsapp.com/send/?phone=51{cliente.telef_secundario}&text&app_absent=0"
                class="fg-success"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-whatsapp"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
                  />
                </svg>
              </a>
            {/if}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</Container>

<Modal
  isOpen={isOpenModalTelefonos}
  on:close={() => (isOpenModalTelefonos = false)}
  title="Agregar teléfono"
>
  <div class="mb-3">
    <label for="tipo" class="form-label">Tipo</label>
    <select
      id="tipo"
      class="form-control form-control-sm"
      bind:value={telefono_tipo}
    >
      <option value="">Seleccionar</option>
      <option value="telef_principal">Principal</option>
      <option value="telef_secundario" disabled={cliente.telef_principal == ""}
        >Secundario</option
      >
    </select>
  </div>

  <div class="mb-3">
    <label for="telefono" class="form-label">Teléfono</label>
    <input
      type="text"
      id="telefono"
      class="form-control form-control-sm"
      maxLength="9"
      bind:value={telefono}
    />
  </div>

  <div class="mb-3 text-end">
    {#if isSettingTelefono}
      <button class="btn btn-solid theme-primary btn-sm disabled" disabled
        >Agregando...</button
      >
    {:else}
      <button class="btn btn-solid theme-primary btn-sm" on:click={updateTelefonoVerificado}
        >Agregar</button
      >
    {/if}
  </div>
</Modal>
